export function buildErrorAlertMessage(errorMessage: string): string | undefined {
    const errorMessageLowerCased = errorMessage.toLowerCase();

    const isSurplusOrMissingColumnError = errorMessageLowerCased.includes('dataset has a surplus column') ||
        errorMessageLowerCased.includes('dataset is missing a column');

    const isVerifyFMCDataError = (errorMessageLowerCased.includes('has no') && errorMessageLowerCased.includes('.csv')) ||
        errorMessageLowerCased.includes('adhoc dataset rootdir is missing') ||
        errorMessageLowerCased.includes('no such directory in fm') ||
        errorMessageLowerCased.includes('invalid opening quote');

    if (isSurplusOrMissingColumnError) {
        return errorMessage;
    } else if (isVerifyFMCDataError) {
        return 'Please verify FMC data';
    }

    return undefined;
}
